export enum Colors {
	'border-white' = 'border-white',
	'white-primary' = 'white-primary',
	'white-secondary' = 'white-secondary',
	'white-tertiary' = 'white-tertiary',
	'white-red' = 'white-red',
	'white-gray' = 'white-gray',
	'white-green' = 'white-green',
	'white-yellow' = 'white-yellow',
	primary = 'primary',
	'primary-light' = 'primary-light',
	'border-primary' = 'border-primary',
	secondary = 'secondary',
	tertiary = 'tertiary',
	'tertiary-dark' = 'tertiary-dark',
	yellow = 'yellow',
	'border-yellow' = 'border-yellow',
	red = 'red',
	'border-red' = 'border-red',
	green = 'green',
	'gray-2' = 'gray-2',
	'gray-3' = 'gray-3',
	'border-gray-3' = 'border-gray-3',
	'gray-4' = 'gray-4',
	'border-gray-4' = 'border-gray-4',
	'gray-5' = 'gray-5',
	'gray-7' = 'gray-7',
	'border-gray-6' = 'border-gray-6',
	success = 'success',
	warning = 'warning',
	error = 'error',
	danger = 'danger',
	muted = 'muted',
	empty = 'empty',
	premium = 'premium',
	association = 'association',
	black = 'black',
	job = 'job'
}

export enum ColorValues {
	primary = '#96BD68',
	'primary-light' = '#AED67E',
	'secondary-light' = '#fcc597',
	tertiary = '#74dbf7',
	'tertiary-light' = '#aae8f2',
	yellow = '#ff9800',
	red = '#f44336',
	green = '#4caf50',
	'gray-1' = '#f2f2f4',
	'gray-2' = '#d5d5db',
	'gray-3' = '#737373',
	'gray-4' = '#5d5c70',
	'gray-5' = '#0c0c0E',
	'gray-6' = '#242429',
}
